'use strict'

const _ = require('lodash')
const ASPECT_NAME = 'popoverAspect'
const privatesMap = new WeakMap()
const ReactDOM = require('react-dom')
const PropTypes = require('prop-types')

const getTargetBounds = (pm, targetId, portalDOM) => {
    const targetElement = pm.aspectProps.getComponentByPageAndCompId(targetId)
    const targetDOM = ReactDOM.findDOMNode(targetElement)
    const targetBoundingRect = targetDOM.getBoundingClientRect()
    const portalBoundingRect = portalDOM.getBoundingClientRect()

    return {
        top: targetBoundingRect.y + pm.aspectProps.getScrollPosition().y,
        left: targetBoundingRect.x - portalBoundingRect.x,
        width: targetBoundingRect.width,
        height: targetBoundingRect.height
    }
}

const clearPrivateMaps = (pm, popoverId) => {
    delete pm.closeRequests[popoverId]
    delete pm.overrideClose[popoverId]
    delete pm.isInPopoverBounds[popoverId]
}

const closePopoverImmediate = (pm, popoverId) => {
    pm.aspectProps.transaction(() => {
        pm.aspectProps.deactivateMode(popoverId)
        pm.storageAPI.set(popoverId, null)
        pm.aspectProps.unRegisterToDocumentClickEvent(popoverId)
    })
    clearPrivateMaps(pm, popoverId)
}

const closeAllPopovers = pm => {
    const openPopoverIds = _.keys(pm.storageAPI.getAll())
    pm.aspectProps.transaction(() => {
        _.forEach(openPopoverIds, popoverId => closePopoverImmediate(pm, popoverId))
    })
}

class PopoverAspect {
    constructor(hostProps, storageAPI = new Map()) {
        privatesMap.set(this, {
            storageAPI,
            aspectProps: hostProps,
            isInPopoverBounds: {},
            closeRequests: {},
            overrideClose: {}
        })
    }
    onHostPropsChanged(nextProps) {
        const pm = privatesMap.get(this)
        if (pm.aspectProps.isPopoverAllowed && !nextProps.isPopoverAllowed) {
            closeAllPopovers(pm)
        }
        if (nextProps.isPopoverAllowed && pm.aspectProps.isMobileView !== nextProps.isMobileView) {
            closeAllPopovers(pm)
        }
        pm.aspectProps = nextProps
    }
    openPopover(popoverId, targetId) {
        const targetPortalDOM = this.getTargetPortal()
        if (!targetPortalDOM) {
            return
        }

        const pm = privatesMap.get(this)

        const timeoutID = pm.closeRequests[popoverId]
        if (timeoutID) {
            clearTimeout(timeoutID)
            delete pm.closeRequests[popoverId]
            return
        }

        pm.aspectProps.transaction(() => {
            pm.aspectProps.activateMode(popoverId)
            pm.storageAPI.set(popoverId, getTargetBounds(pm, targetId, targetPortalDOM))
            pm.aspectProps.registerToDocumentClickEvent(popoverId)
        })
    }
    reportMouseIn(popoverId) {
        const pm = privatesMap.get(this)
        pm.isInPopoverBounds[popoverId] = true
        const timeoutID = pm.closeRequests[popoverId]
        if (timeoutID) {
            clearTimeout(timeoutID)
            delete pm.closeRequests[popoverId]
            pm.overrideClose[popoverId] = true
        }
    }
    reportMouseOut(popoverId) {
        const pm = privatesMap.get(this)
        delete pm.isInPopoverBounds[popoverId]
        const shouldCloseOnMouseOut = pm.overrideClose[popoverId]
        if (shouldCloseOnMouseOut) {
            this.closePopover(popoverId)
        }
    }
    closePopover(popoverId, forceClose) {
        const pm = privatesMap.get(this)
        if (forceClose) {
            closePopoverImmediate(pm, popoverId)
        } else if (pm.isInPopoverBounds[popoverId]) {
            pm.overrideClose[popoverId] = true
        } else {
            pm.closeRequests[popoverId] = setTimeout(closePopoverImmediate.bind(null, pm, popoverId), 500)
        }
    }
    getTargetBounds(popoverId) {
        return privatesMap.get(this).storageAPI.get(popoverId)
    }
    getTargetPortal() {
        const pm = privatesMap.get(this)
        return pm.aspectProps.getTargetPortal()
    }
}

PopoverAspect.aspectName = ASPECT_NAME

PopoverAspect.hostPropTypes = {
    deactivateMode: PropTypes.func.isRequired,
    activateMode: PropTypes.func.isRequired,
    getComponentByPageAndCompId: PropTypes.func.isRequired,
    getScrollPosition: PropTypes.func.isRequired,
    transaction: PropTypes.func.isRequired,
    getTargetPortal: PropTypes.func.isRequired,
    registerToDocumentClickEvent: PropTypes.func.isRequired,
    unRegisterToDocumentClickEvent: PropTypes.func.isRequired,
    isPopoverAllowed: PropTypes.bool.isRequired,
    isMobileView: PropTypes.bool.isRequired
}

module.exports = PopoverAspect